import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import s from './styles';

function SelectProfileCustomer() {
  const [select, setSelet] = useState('all');
  const { t } = useTranslation();

  return (
    <s.Wrapper>
      <s.WrapperBottomComponents>
        <s.DataSelector>
          <s.DateSelectorItem
            selected={select === 'all'}
            left
            style={{ borderRadius: '2px 0  0 2px' }}
            onClick={() => setSelet('all')}
          >
            {t('components.Reservation.TopMenu.upcomming')}
          </s.DateSelectorItem>
          <s.DateSelectorItem
            selected={select === 'person'}
            onClick={() => setSelet('person')}
          >
            {t('components.Reservation.TopMenu.past')}
          </s.DateSelectorItem>
          <s.DateSelectorItem
            selected={select === 'business'}
            style={{ borderRadius: '0 2px 2px 0' }}
            onClick={() => setSelet('business')}
          >
            {t('components.Reservation.TopMenu.cancelled')}
          </s.DateSelectorItem>
        </s.DataSelector>
      </s.WrapperBottomComponents>
    </s.Wrapper>
  );
}

export default SelectProfileCustomer;
